/** Resolve `fallback` if `promise` rejects or takes longer than `ms`. Never rejects. */
export function withTimeout<T>(promise: Promise<T>, fallback: T, ms: number): Promise<T> {
  let timer: ReturnType<typeof setTimeout> | undefined
  return Promise.race([
    promise.catch(() => fallback),
    new Promise<T>((resolve) => {
      timer = setTimeout(() => resolve(fallback), ms)
    }),
  ]).finally(() => {
    if (timer) clearTimeout(timer)
  })
}
